import React from "react";

function FrontArrow() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1101 2.17945C8.7801 1.85945 8.2601 1.85945 7.9301 2.17945C7.6101 2.50945 7.6101 3.02945 7.9301 3.35945L12.3401 7.76945H2.6901C2.2301 7.76945 1.8501 8.13945 1.8501 8.59945C1.8501 9.05945 2.2301 9.42945 2.6901 9.42945H12.3401L7.9301 13.8395C7.6101 14.1695 7.6101 14.6895 7.9301 15.0195C8.2601 15.3395 8.7801 15.3395 9.1101 15.0195L14.9401 9.18945C15.2701 8.86945 15.2701 8.33945 14.9401 8.00945L9.1101 2.17945Z"
        fill="white"
      />
    </svg>
  );
}

export default FrontArrow;
